import styled from "styled-components";

export const CommitmentQuestion = styled.div`
  margin-bottom: 8px;
  padding-left: 50px;
  width: 100%;
  min-height: 54px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  cursor: ${({ cursor, isDisabledInputs }) => !isDisabledInputs && cursor};
  position: relative;
  &:hover {
    transform: ${({ isDisabledInputs }) => !isDisabledInputs && "translateY(-3px)"};
    box-shadow: ${({ isDisabledInputs }) => !isDisabledInputs && "0 0 20px rgba(0, 0, 0, 0.4)"};
  }
`;
export const CheckDiv = styled.div`
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px 0 0 5px;
  background-color: ${({ background }) => background && background};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
`;
export const CheckImg = styled.img``;
export const QuestionText = styled.p`
  font-size: 16px;
  color: #000;
`;
